const NONE = 'None';
const CREATE = 'Create';
const EDIT = 'Edit';
const DUPLICATE = 'Duplicate';
const DELETE = 'Delete';
const ARCHIVE = 'Archive';
const VIEW = 'View';

export const ManagerCreateRequestsAction = Object.freeze({
    [NONE]: 0,
    [CREATE]: 1,
    [EDIT]: 2,
    [DUPLICATE]: 3,
    [DELETE]: 4,
    [ARCHIVE]: 5,
    [VIEW]: 6,
});

const IndexedManagerCreateRequestsAction = Object.freeze({
    0: NONE,
    1: CREATE,
    2: EDIT,
    3: DUPLICATE,
    4: DELETE,
    5: ARCHIVE,
    6: VIEW,
});

export const ManagerCreateRequestsActionNames = Object.freeze({
    None: IndexedManagerCreateRequestsAction[ManagerCreateRequestsAction.None],
    Create: IndexedManagerCreateRequestsAction[ManagerCreateRequestsAction.Create],
    Edit: IndexedManagerCreateRequestsAction[ManagerCreateRequestsAction.Edit],
    Duplicate: IndexedManagerCreateRequestsAction[ManagerCreateRequestsAction.Duplicate],
    Delete: IndexedManagerCreateRequestsAction[ManagerCreateRequestsAction.Delete],
    Archive: IndexedManagerCreateRequestsAction[ManagerCreateRequestsAction.Archive],
    View: IndexedManagerCreateRequestsAction[ManagerCreateRequestsAction.View],
});
